// extracted by mini-css-extract-plugin
module.exports = {"related-story":"relatedStory-m__related-story__2XA0d"};